
/**
 * @typedef {import('../../../models/dt-gpt.model').Message} Message
 */

import * as types from './types';
import * as I18nTypes from '../i18n/types';
import { AccountService } from '../../../services/account.service';
import { MODIFICATION_URL } from '../../../services/common-urls';
import { HttpClient } from '../../../services/http/http-client';
import { DtGPTDetailsAPIService, DtGPTService, DtGPTStoreService, GPTContextService } from '../../../services/dt-gpt.service';
import AppRouter from '../../../router';
import router from '../../../router';
import { uuidv4 } from '../../../utility';
import { isNotEmpty } from 'ramda';
import { pick } from 'ramda';


export const dtGPTActions = {
  async [types.DtGPTChats.FETCH.ALL]({ commit, getters, dispatch }) {
    const chats = await DtGPTService.getAllMessages();
    console.log({ 'actions.js:11 chats': chats });
    commit(types.DtGPTChats.SET, chats);
  },
  async [types.DtGPTChats.FETCH.SINGLE]({ commit, getters, dispatch }, { conversation_id }) {
    const conversationDetails = await DtGPTService.getConversation(conversation_id);
    console.log({ 'actions.js:11 chats': conversationDetails });
    commit(types.DtGPTChat.SET.SINGLE, {
      ...conversationDetails.data,
      messages: JSON.parse(conversationDetails.data.messages),
    });
    console.log({
      'cd': {
        ...conversationDetails.data,
        messages: JSON.parse(conversationDetails.data.messages),
      }
    });
  },
  async [types.DtGPTConversations.FETCH.ALL]({ commit, getters, dispatch }) {
    const allConversations = await DtGPTService.getAllConversations();

    commit(types.DtGPTConversations.SET.ALL, allConversations);
    console.log({ 'actions.js:11 allConversations': allConversations });
  },
  async [types.DtGPTConversations.DELETE.SINGLE]({ commit, getters, dispatch }, { conversation_id }) {

    commit(types.DtGPTConversations.SET.ALL, {
      ...getters.conversations,
      data: getters.conversations.data.filter(conversation => conversation.conversation_id !== conversation_id),
    });

    // If the conversation is the current conversation, then delete the current conversation
    if (getters.chat.conversation_id === conversation_id) {
      commit(types.DtGPTChat.SET.SINGLE, {
        conversation_id: "undefined",
        title: "Chat",
        messages: [],
      });
    }


    const deleteResponse = await DtGPTService.deleteConversation(conversation_id);
    console.log({ 'actions.js:11 deleteResponse': deleteResponse });

  },
  async [types.SEND_CHAT_MESSAGE]({ commit, getters, dispatch }, { text }) {

    console.log({ 'actions.js:15 message': text });

    // Update message sending and getting response loading flag in Store
    commit(types.SET_SEND_CHAT_MESSAGE_LOADING, true);

    let currentConversationId = getters.chat.conversation_id;
    const userMessage = {
      content: {
        text,
      },
      sender: 'user'
    };


    if (currentConversationId === 'undefined' || currentConversationId === undefined || currentConversationId === null) {

      /**
        const addedConversation = await DtGPTService.addConversation(`Chat ${uuidv4()}`, 'General');
        currentConversationId = addedConversation?.data?.conversation_id;
        await DtGPTService.addMessageToConversation(currentConversationId, JSON.stringify({
          content: {
            text,
          },
          sender: 'user'
        }))

        // Update chat ID in Store
        commit(types.DtGPTChat.SET.SINGLE, {
          ...getters.chat,
          conversation_id: currentConversationId,
        });
       */




    } else {
      // Add Message to Existing Chat
      const addedMessage = await DtGPTService.addMessageToConversation(currentConversationId, JSON.stringify(userMessage));
    }

    commit(types.DtGPTChat.SET.SINGLE, {
      ...getters.chat,
      messages: [...getters.chat.messages, userMessage]
    });


    /** @type {Message} */
    let findCommandResponse;


    // Get Context from the Vue Store

    console.log(router.currentRoute);
    console.log(router);
    console.log(getters);
    console.log({ 'actions.js:61 existingChatID': currentConversationId });

    // const context = DtGPTStoreService.getContext(router.currentRoute, getters);
    const context = {
      route: {
        name: router.currentRoute?.name,
        path: router.currentRoute?.path,
        query: router.currentRoute?.query,
        params: router.currentRoute?.params,
      }
    };


    findCommandResponse = await DtGPTService.sendCommandFind(text, context, getters.chat.messages);


    const foundCommand = findCommandResponse.command;

    if (foundCommand) {

      await performCommand(foundCommand, getters, text, context, commit);

    } else if (findCommandResponse.success === true) {
      // This is for Routing Commands
      // If Valid Path -

      const path = findCommandResponse?.path;
      if (path !== null && path !== undefined) {
        console.log(`Navigating to ${path}`);
        AppRouter.push({
          path: path
        });

      }

      const newResponseMessage = {
        sender: 'bot',
        content: findCommandResponse,
        timestamp: new Date(),
      }

      // Add Message to Existing Chat
      await DtGPTService.addMessageToConversation(currentConversationId, JSON.stringify(newResponseMessage));

      await saveConversationMessage(getters, commit, newResponseMessage);

    } else if (findCommandResponse.success === false && getters.chat?.lastCommand) {
      // This is for Valid Last Command and Fill Response

      const lastCommand = getters.chat.lastCommand;
      console.log({ 'Performing lastCommand': lastCommand });

      await performCommand(lastCommand, getters, text, context, commit);

    } else {

      console.log({ 'actions.js:63 msgResponse': findCommandResponse });

      const newResponseMessage = {
        sender: 'bot',
        content: findCommandResponse,
        timestamp: new Date(),
      }

      // await DtGPTService.addMessageToConversation(currentConversationId, JSON.stringify(newResponseMessage));
      await saveConversationMessage(getters, commit, newResponseMessage);
    }

    // Update message sending and getting response loading flag in Store
    commit(types.SET_SEND_CHAT_MESSAGE_LOADING, false);

  },
  async [types.CLICK_NEW_MESSAGE]({ commit }) {
    commit(types.DtGPTChat.SET.SINGLE, {
      id: "undefined",
      title: "Chat",
      messages: [],
    });
  },

  async [types.SET_CHAT_MESSAGES]({ getters, commit }, messages) {
    commit(types.DtGPTChat.SET.SINGLE, {
      ...getters.chat,
      messages
    });
  },

  // async [types.SEND_CHAT_MESSAGE]({ commit, getters, dispatch }, { text }) {

  //   console.log({ 'actions.js:15 message': text });

  //   const existingChatID = getters.chat.conversation_id;

  //   commit(types.DtGPTChat.SET.SINGLE, {
  //     ...getters.chat,
  //     messages: [...getters.chat.messages, {
  //       content: {
  //         text,
  //       },
  //       sender: 'user'
  //     }]
  //   });


  //   /** @type {Message} */
  //   let msgResponse;


  //   // Get Context from the Vue Store

  //   console.log(router.currentRoute);
  //   console.log(router);
  //   console.log(getters);

  //   const context = DtGPTStoreService.getContext(router.currentRoute, getters);

  //   // console.log({context});

  //   // return;


  //   if (existingChatID !== undefined && existingChatID !== null && existingChatID !== 'undefined') {
  //     msgResponse = await DtGPTService.sendChatMessage(existingChatID, text, context);
  //   } else {
  //     msgResponse = await DtGPTService.sendNewMessage(text, context);
  //   }

  //   console.log({ 'actions.js:16 newMessage': msgResponse });




  //   let apiResponse;

  //   if (msgResponse.response.content.success) {

  //     if (msgResponse.response.content.args && msgResponse.response.content?.command?.metadata?.command_type === 'list') {

  //       const section = msgResponse?.response?.content?.command?.metadata?.section || '';
  //       const action = msgResponse?.response?.content?.command?.metadata?.action || '';

  //       apiResponse = await DtGPTDetailsAPIService.httpGet(msgResponse.response.content.command.identifier_of_api_point, {
  //         section: section,
  //         action: action,
  //         ...msgResponse.response.content.args,
  //       });
  //       console.log({ 'actions.js:74 msgResponse.response.content.args': msgResponse.response.content.args });


  //       console.log({ 'actions.js:34 apiResponse': apiResponse });
  //     }
  //   }




  //   commit(types.DtGPTChat.SET.SINGLE, {
  //     ...getters.chat,
  //     id: msgResponse.id,
  //     messages: [...getters.chat.messages, {
  //       ...msgResponse.response,
  //       api_response: apiResponse,
  //     }]
  //   });



  //   // If Valid Path - 
  //   const path = msgResponse?.response?.content?.path;
  //   console.log({ 'actions.js:34 path': path });
  //   if (path !== null && path !== undefined) {
  //     console.log(`Navigating to ${path}`);
  //     AppRouter.push({
  //       path: path
  //     });
  //   }
  // },
  // async [types.CLICK_NEW_MESSAGE]({ commit }) {
  //   commit(types.DtGPTChat.SET.SINGLE, {
  //     id: "undefined",
  //     title: "Chat",
  //     messages: [],
  //   });
  // },
}

async function performCommand(foundCommand, getters, text, context, commit) {
  const contextSchema = foundCommand.metadata.context_schema;
  console.log({ 'actions.js:77 contextSchema': contextSchema });

  const contextData = {};
  let saveCommand = foundCommand;

  for (const key in contextSchema) {
    const value = contextSchema[key];
    console.log({ 'actions.js:84 value': value });

    if (value.type === 'function') {
      contextData[key] = await GPTContextService?.[value?.service]?.[value?.function_name]();
      console.log(contextData[key]);
    }

    if (value.type === 'store') {
      contextData[key] = DtGPTStoreService.getContext2(router.currentRoute, getters, value.getter, value.mapper);
    }

    if (value.type === 'javascript') {
      // biome-ignore lint/security/noGlobalEval: We have to support Custom Javascript Code Execution
      contextData[key] = await eval(value?.code);
    }


    //   const demoCode = `HttpClient.post2('/booking.pl', {
    //   section: 'location',
    //   action: 'location_page',
    //   startrow: 0
    // }).then(res=>res)`


  }

  console.log({ 'actions.js:84 contextData': contextData });


  const fillResponse = await DtGPTService.sendCommandFill(text, {
    ...context,
    ...contextData,
    command: foundCommand
  }, getters.chat.messages);

  console.log({ 'actions.js:125 fillResponse': fillResponse });

  let apiResponse;
  if (fillResponse.success === true) {

    if (fillResponse?.args && fillResponse?.command?.metadata?.command_type === 'list') {

      const section = fillResponse?.command?.metadata?.section || '';
      const action = fillResponse?.command?.metadata?.action || '';

      apiResponse = await DtGPTDetailsAPIService.httpGet(fillResponse.command.identifier_of_api_point, {
        section: section,
        action: action,
        ...fillResponse.args,
      });

    }

    if (fillResponse?.args && fillResponse?.command?.metadata?.command_type === 'route') {

      if (fillResponse?.command?.metadata?.route?.path) {
        const path = fillResponse?.command?.metadata?.route?.path || '';

        AppRouter.push({
          path: constructFinalPath(path, fillResponse.args),
        });
        
      } else if (fillResponse?.args?.path) {
        AppRouter.push({
          path: fillResponse?.args?.path,
        });
      }


    }

    saveCommand = undefined;
  }

  const newMessageResponse = {
    sender: 'bot',
    content: fillResponse,
    timestamp: new Date(),

    api_response: apiResponse,
  }

  // commit(types.DtGPTChat.SET.SINGLE, {
  //   ...getters.chat,
  //   lastCommand: saveCommand,
  //   messages: [...getters.chat.messages, newMessageResponse]
  // });

  const leanNewMessageResponse = {
    sender: 'bot',
    content: pick(['args', 'command', 'response', 'success'], fillResponse),
    timestamp: new Date(),
    api_response: apiResponse
  }

  // Save the lastCommand

  if (saveCommand) {
    commit(types.DtGPTChat.SET.SINGLE, {
      ...getters.chat,
      lastCommand: saveCommand,
    });
  }

  await saveConversation(getters, commit, leanNewMessageResponse, 'General');

}


const constructFinalPath = (path, args) => {
  const replacedPath = Object.keys(args).reduce((accPath, key) => {
    return accPath.replace(`<${key}>`, (match) => {
      if (match === `<${key}>`) {
        return args[key];
      }
      return match;
    });
  }, path);

  const remainingArgs = Object.keys(args).reduce((acc, key) => {
    if (!path.includes(`<${key}>`)) {
      acc[key] = args[key];
    }
    return acc;
  }, {});

  const queryParams = new URLSearchParams(remainingArgs).toString();

  return queryParams ? `${replacedPath}?${queryParams}` : replacedPath;
};


async function saveConversation(getters, commit, newMessageResponse, section = 'General') {


  let currentConversationId = getters.chat.conversation_id;

  console.log({
    'actions.js:125 saveConversation': {
      getters,
      commit,
      newMessageResponse,
      section
    }
  });

  const messages = [...getters.chat.messages, newMessageResponse];

  commit(types.DtGPTChat.SET.SINGLE, {
    ...getters.chat,
    messages,
  });


  if (currentConversationId === 'undefined' || currentConversationId === undefined || currentConversationId === null) {
    const addedConversation = await DtGPTService.addConversation(`Chat ${uuidv4()}`, section, JSON.stringify(messages));
    console.log({ 'actions.js:40 addedConversation': addedConversation });

    currentConversationId = addedConversation?.data?.conversation_id;
    // Update chat ID in Store
    commit(types.DtGPTChat.SET.SINGLE, {
      ...getters.chat,
      conversation_id: addedConversation?.data?.conversation_id,
    });

    // find text from messages
    const text = getters.chat.messages.find(message => message.sender === 'user')?.content?.text;
    console.log({ 'actions.js:432 text': text });

    DtGPTService.nameConversation(text).then(nameResponse => {
      console.log(nameResponse);

      DtGPTService.modifyConversationTitle(currentConversationId, nameResponse?.name).then(modifyResponse => {
        console.log(modifyResponse);

        // Update Chat Title in Store
        commit(types.DtGPTChat.SET.SINGLE, {
          ...getters.chat,
          title: nameResponse?.name,
        });
      });

      // Add Current Conversation to the Conversation List Store
      commit(types.DtGPTConversations.SET.ALL, {
        ...getters.conversations,
        data: [
          {
            conversation_id: currentConversationId,
            title: nameResponse?.name,
          },
          ...getters.conversations.data,
        ]
      });
    });
  } else {
    await DtGPTService.addMessageToConversation(currentConversationId, JSON.stringify(newMessageResponse));
  }


  return currentConversationId;
}

async function saveConversationMessage(getters, commit, message) {
  const currentConversationId = getters.chat.conversation_id;

  commit(types.DtGPTChat.SET.SINGLE, {
    ...getters.chat,
    messages: [...getters.chat.messages, message]
  });

  if (currentConversationId === 'undefined' || currentConversationId === undefined || currentConversationId === null) {
    // Do Nothing
  } else {
    await DtGPTService.addMessageToConversation(currentConversationId, JSON.stringify(message));
  }


  // Save the Message to the Store

}

